


<div class="new-line-fields">
<button mat-raised-button (click)="prevWeek(schedule)" class="example-form-field">Vorige week</button>
<button mat-raised-button (click)="nextWeek(schedule)" class="example-form-field">Volgende week</button>
</div>

<div class="programmatietable" *ngIf="schedule">
  <div class="programmatierow">
    <div class="programmatiecol" *ngFor="let columnd of schedule.programmatielijn.details">
      <div class="programmatieheader">
        {{ columnd.programmatiecolumn.day }} <br>
        {{ columnd.programmatiecolumn.date }} <br>
        <br>
      </div>
      <div *ngFor="let blokd of columnd.programmatiecolumn.blokken">
        <div class="programmatieitem" (click)="scheduleClicked(blokd)" [ngClass]="blokd.programmatieblok.class" >
          {{ blokd.programmatieblok.showName }}<br>
          {{ blokd.programmatieblok.startClockCalc }} - {{ blokd.programmatieblok.endClockCalc }}
        </div>
      </div>
    </div>
  </div>
</div>